import { lowerCase } from 'es-toolkit';
import { Timestamp } from 'firebase/firestore';
import { PccDataSidePanelTypes } from '@ss/typings/pcc';

export class BaseSource {
	sourceId?: string;

	quote?: string;

	distance?: number;

	sourceType: 'chunk' | 'pccData';

	addedAt?: Date;

	new?: boolean;
}

export class DocumentChunkSource extends BaseSource {
	page: number;

	isUnverified?: boolean;

	viewed: boolean;

	fileId?: string;

	sourceFilename?: string;

	chunkId?: string;

	rawText?: string;

	fromResourceFile?: boolean;

	declare sourceType: 'chunk';

	constructor(partial?: Partial<DocumentChunkSource>) {
		super();
		Object.assign(this, partial);
		this.sourceType = 'chunk';
		if (this.addedAt instanceof Timestamp) {
			this.addedAt = this.addedAt.toDate();
		}
	}
}

export class PccDataSource extends BaseSource {
	type: PccDataSidePanelTypes;

	label?: string;

	pccDataId: number;

	metadata: Record<string, string | number | boolean | undefined>;

	details?: string;

	declare sourceType: 'pccData';

	accessRestriction?: boolean;

	constructor(partial?: Partial<PccDataSource>) {
		super();
		Object.assign(this, partial);
		this.sourceType = 'pccData';
		if (!this.type) this.type = 'progressNote';
		this.label = lowerCase(this.type);
		if (this.addedAt instanceof Timestamp) {
			this.addedAt = this.addedAt.toDate();
		}
	}
}

export type FindingResponseSource = DocumentChunkSource | PccDataSource;

/** Same citation as persisted Firestore maps, model output, or UI (order-independent). */
export function findingResponseSourcesMatch(
	a: FindingResponseSource | Record<string, unknown>,
	b: FindingResponseSource | Record<string, unknown>
): boolean {
	const ar = a as Record<string, unknown>;
	const br = b as Record<string, unknown>;
	if (ar.sourceId && br.sourceId) return ar.sourceId === br.sourceId;
	if (ar.sourceType !== br.sourceType) return false;

	switch (ar.sourceType) {
		case 'pccData':
			return Number(ar.pccDataId) === Number(br.pccDataId) && String(ar.type ?? '') === String(br.type ?? '');
		case 'chunk':
			if (ar.chunkId !== br.chunkId) return false;
			if (ar.fileId !== br.fileId) return false;
			return true;
		default:
			return false;
	}
}
